import { useTranslation } from 'react-i18next';
import { Button } from 'shared/components/button';
import { Props } from 'shared/@types';
import { useOpenLogin } from 'shared/state/login';

export const LoginButton = ({ dense, className }: Props<{ dense?: boolean }>) => {
  const { t } = useTranslation('web');
  const openLogin = useOpenLogin();

  return (
    <Button
      text={t('layout.menu.sign_in')}
      dense={dense}
      className={className}
      onPress={() => {
        openLogin({ source: 'login-button' });
      }}
    />
  );
};
